import styled from '@emotion/styled';
import React, { useEffect } from 'react';

const Scroller = styled.div<{ absolute?: boolean }>`
  width: 10px !important;
  height: 10px !important;

  ${({ absolute = true }) => {
    if (!absolute) return '';

    return `
      position: absolute;
      bottom: 0;
    `;
  }}
`;

type InfiniteScrollProps = {
  onInfiniteScroll?: () => void;
  absolute?: boolean;
};

const InfiniteScroll = (props: InfiniteScrollProps) => {
  const { onInfiniteScroll, absolute } = props;
  const ref = React.useRef<HTMLDivElement>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome migration; the app is already working as expected with these dependency arrays
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            onInfiniteScroll?.();
            observer.disconnect();
          }
        });
      },
      { root: null, rootMargin: '100px', threshold: 0.01 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => {
      if (ref.current) observer?.unobserve(ref.current as Element);
    };
  }, []);

  return <Scroller ref={ref} absolute={absolute} />;
};

export default InfiniteScroll;
